import { tr } from '@/lib/i18n-core';
import { useState } from 'react';
import { Dialog } from '@/components/ui/layout';
import { Alert, Button, Field, Textarea } from '@/components/ui/primitives';

export function LabBenchReasonDialog({
  title,
  description,
  label,
  confirmLabel,
  minLength,
  maxLength = 300,
  destructive,
  pending,
  error,
  onSubmit,
  onClose,
}: {
  title: string;
  description?: string;
  label: string;
  confirmLabel: string;
  minLength: number;
  maxLength?: number;
  destructive?: boolean;
  pending?: boolean;
  error?: string | null;
  onSubmit: (reason: string) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const valid = trimmed.length >= minLength;

  return (
    <Dialog
      open
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {tr('lab', 'back')}
          </Button>
          <Button variant={destructive ? 'destructive' : 'default'} onClick={() => onSubmit(trimmed)} loading={pending} disabled={!valid}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        {error && <Alert variant="destructive">{error}</Alert>}
        <Field label={label} required hint={tr('lab', 'at_least_x_characters_it_is_kept_in_the_audit', { minLength: minLength })}>
          <Textarea rows={3} value={reason} maxLength={maxLength} onChange={(e) => setReason(e.target.value)} />
        </Field>
      </div>
    </Dialog>
  );
}
